export default "<p>edit-workreport-dialog works!</p>\n"